import { accountIdFormat } from "@redotech/redo-account-id";
import * as z from "zod";

export const MerchantSkuOptionSchema = z.object({
  sku: z.string(),
  title: z.string(),
});

export const searchMerchantSkus = {
  name: "searchMerchantSkus" as const,
  input: z.object({
    merchantAccountId: accountIdFormat.schema,
    query: z.string().max(255),
  }),
  output: z.object({ skus: z.array(MerchantSkuOptionSchema) }),
};
